import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    event.preventDefault()

    const el = event.currentTarget
    const isLink = el.tagName === "A"
    const url  = isLink ? el.href : el.action
    const body = isLink ? null : new FormData(el)

    fetch(url, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
        "Accept": "application/json",
      },
      body,
    })
      .then(r => r.json())
      .then(({ cart_html, modal_html }) => {
        document.querySelectorAll(".navbar-cart-wrapper").forEach(el => el.innerHTML = cart_html)
        document.getElementById("modal-warehouse").innerHTML = modal_html
        $("#modal-item-added").modal("show")
      })
  }
}
